import React, { useEffect, useState, PropsWithChildren } from "react";
import { authService } from "../services/Services";
import { Box, CircularProgress } from "@mui/material";

/**
 * AuthInitializer ensures that the session recovery is complete before rendering the app.
 */
export const AuthInitializer: React.FC<PropsWithChildren> = ({ children }) => {
    const [isReady, setIsReady] = useState(authService.isSessionReady());

    useEffect(() => {
        const initializeAuth = async () => {
            try {
                await authService.initializeSession();
            } catch (error) {
                console.warn("Session initialization encountered an error:", error);
            } finally {
                setIsReady(true);
            }
        };

        initializeAuth();
    }, []);

    if (!isReady) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return <>{children}</>;
};
